import { apiClient } from '@/services/apiClient';
import type { TResponse, TResponsePayload } from '@/types/global';
import { type IRegion } from '@/types/regions';

export const createRegion = (params: any) => apiClient.post('/region', params);

export const getRegions = () => apiClient.get<TResponse<TResponsePayload<IRegion>>>('/region');
